var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOysterHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42857 22H3.71429C2.21523 22 1 20.7763 1 19.2667V9.59052C1 8.79253 1.34625 8.03446 1.94786 7.51518L8.73354 1.65803C9.75004 0.780657 11.25 0.780657 12.2665 1.65803L19.0522 7.51518C19.6538 8.03446 20 8.79253 20 9.59052V19.2667C20 20.7763 18.7848 22 17.2857 22H14.5714M6.42857 22V13.8C6.42857 13.0452 7.03619 12.4333 7.78571 12.4333H13.2143C13.9638 12.4333 14.5714 13.0452 14.5714 13.8V22M6.42857 22H14.5714",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOysterHome);
export default __webpack_public_path__ + "static/media/oyster-home.f7a5f9a6b3cf069ef7adfb882864d040.svg";
export { ForwardRef as ReactComponent };